var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74995 1.5H3.72495C3.18789 1.5 2.67282 1.73705 2.29306 2.15901C1.9133 2.58097 1.69995 3.15326 1.69995 3.75V20.25C1.69995 20.8467 1.9133 21.419 2.29306 21.841C2.67282 22.2629 3.18789 22.5 3.72495 22.5H10.475C11.012 22.5 11.5271 22.2629 11.9068 21.841C12.2866 21.419 12.5 20.8467 12.5 20.25V3.75C12.5 3.15326 12.2866 2.58097 11.9068 2.15901C11.5271 1.73705 11.012 1.5 10.475 1.5H8.44995M5.74995 1.5V3H8.44995V1.5M5.74995 1.5H8.44995M5.74995 20.25H8.44995",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.44a0cb47220c39cdf6d1aa1884e7781c.svg";
export { ForwardRef as ReactComponent };